import React from 'react';

import { addZeroToOneDecimal } from 'utils/numbersShowingUtils';

import classes from './PlanPricePro.module.scss';

const PlanPricePro = ({ period, data, isPayment = false, isPro = false, tagline }) => {
    const savingData = isPro
        ? (period === 'Annual' ? data.pro_yearly : data.pro_monthly)
        : (period === 'Annual' ? data.yearly : data.monthly);

    return (
        <>
            {isPro ?
                <div className={classes['pro-badge']}>Pro</div>
                :
                <div className={classes['plus-badge']}>Plus</div>
            }
            {tagline && <div className={classes['tagline']}>{tagline}</div>}

            <div className={`${isPayment ? `${classes['is-payment']} ${classes['price']}` : classes['price']}`}>
                {(period === 'Annual' && !isPro) &&
                    (<>
                        <span className={data.yearly.discounted_price != null ? classes['discounted'] : ''}>
                            {data.yearly.discounted_price != null ?
                                <>
                                    <div className={isPro ? classes['orginal-price-pro'] : classes['orginal-price']}>
                                        <sup className={classes['price-symbol']}>{data.yearly.currency.symbol}</sup>{addZeroToOneDecimal(data.yearly.price)}
                                    </div>
                                    <sup className={classes['symbol']}>
                                        {data.yearly.currency.symbol}
                                    </sup>
                                    {addZeroToOneDecimal(data.yearly.discounted_price)}
                                </>
                                :
                                <>
                                    <sup className={`${classes['symbol']} ${classes['price-symbol']}`}>
                                        {data.yearly.currency.symbol}
                                    </sup>
                                    {addZeroToOneDecimal(data.yearly.price)}
                                </>
                            }
                        </span>
                        <span className={classes['duration']}>
                            /mo
                        </span>
                    </>)
                }
                {(period === 'Monthly' && !isPro) && (
                    <>
                        <span className={data.monthly.discounted_price != null ? classes['discounted'] : ''}>
                            {data.monthly.discounted_price != null ?
                                <>
                                    <div className={isPro ? classes['orginal-price-pro'] : classes['orginal-price']}>
                                        <sup className={classes['price-symbol']}>{data.monthly.currency.symbol}</sup>{addZeroToOneDecimal(data.monthly.price)}
                                    </div>
                                    <sup className={classes['symbol']}>
                                        {data.monthly.currency.symbol}
                                    </sup>
                                    {addZeroToOneDecimal(data.monthly.discounted_price)}
                                </>
                                :
                                <>
                                    <sup className={`${classes['symbol']} ${classes['price-symbol']}`}>
                                        {data.monthly.currency.symbol}
                                    </sup>
                                    {addZeroToOneDecimal(data.monthly.price)}
                                </>
                            }
                        </span>
                        <span className={classes['duration']}>
                            /mo
                        </span>
                    </>)
                }
                {(period === 'Annual' && isPro) &&
                    (<>
                        <span className={data.pro_yearly.discounted_price != null ? classes['discounted'] : ''}>
                            {data.pro_yearly.discounted_price != null ?
                                <>
                                    <div className={isPro ? classes['orginal-price-pro'] : classes['orginal-price']}>
                                        <sup className={classes['price-symbol']}>{data.pro_yearly.currency.symbol}</sup>{addZeroToOneDecimal(data.pro_yearly.price)}
                                    </div>
                                    <sup className={classes['symbol']}>
                                        {data.pro_yearly.currency.symbol}
                                    </sup>
                                    {addZeroToOneDecimal(data.pro_yearly.discounted_price)}
                                </>
                                :
                                <>
                                    <sup className={`${classes['symbol']} ${classes['price-symbol']}`}>
                                        {data.pro_yearly.currency.symbol}
                                    </sup>
                                    {addZeroToOneDecimal(data.pro_yearly.price)}
                                </>
                            }
                        </span>
                        <span className={classes['duration']}>
                            /mo
                        </span>
                    </>)
                }
                {(period === 'Monthly' && isPro) && (
                    <>
                        <span className={data.pro_monthly.discounted_price != null ? classes['discounted'] : ''}>
                            {data.pro_monthly.discounted_price != null ?
                                <>
                                    <div className={isPro ? classes['orginal-price-pro'] : classes['orginal-price']}>
                                        <sup className={classes['price-symbol']}>{data.pro_monthly.currency.symbol}</sup>{addZeroToOneDecimal(data.pro_monthly.price)}
                                    </div>
                                    <sup className={classes['symbol']}>
                                        {data.pro_monthly.currency.symbol}
                                    </sup>
                                    {addZeroToOneDecimal(data.pro_monthly.discounted_price)}
                                </>
                                :
                                <>
                                    <sup className={`${classes['symbol']} ${classes['price-symbol']}`}>
                                        {data.pro_monthly.currency.symbol}
                                    </sup>
                                    {addZeroToOneDecimal(data.pro_monthly.price)}
                                </>
                            }
                        </span>
                        <span className={classes['duration']}>
                            /mo
                        </span>
                    </>)
                }
            </div>
            <div className={`${isPayment ? `${classes['is-payment']} ${classes['save']}` : classes['save']}`}>
                {period === 'Annual'
                    ? <>Save {savingData.currency.symbol}{savingData.saving} <span>| Billed Yearly</span></>
                    : <span>Billed Monthly</span>
                }
            </div>

        </>
    );
};

export default PlanPricePro;